module.exports = __webpack_public_path__ + "img/style_3_1.bfc2a85d.png";